import { Injectable, RendererFactory2, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public changeFavicon(url: string): void {
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    this.clearFavicon();
    this.renderer.appendChild(this.document.head, link);
  }

  private clearFavicon(): void {
    const links: HTMLCollectionOf<HTMLLinkElement> = this.document.getElementsByTagName('link');
    for (let i = links.length - 1; i >= 0; i--) {
      if (links[i].getAttribute('rel') === 'icon' || links[i].getAttribute('rel') === 'shortcut icon') {
        this.renderer.removeChild(this.document.head, links[i]);
      }
    }
  }

  changeTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }
}